import React, { Component } from "react";
import styles from "./winterMaintenceMapWrapper.module.scss";
import { withWinterMaintence } from "../../../shared/containers/containerWinterMaintence";
import WinterMaintenceCompaniesTools from "./WinterMaintenceCompaniesTools";
import { states } from "../../../reducers/queriesStates";

class WinterParentCompanyTools extends Component {
  constructor(props) {
    super(props);

    this.state = { isChecked: true };
  }

  componentDidUpdate(prevProps) {
    const { winterArea, parentCompany, winterAreasFilter, currentFilter } = this.props;
    const { isChecked } = this.state;

    // // const currentFilter = winterAreasFilter.filter((x) => {
    // //   return x.winterAreaId === winterArea.id;
    // // })[0];

    const isParentChecked = currentFilter.parentCompanies.some((x) => {
      return x === parentCompany.id;
    });

    if (isChecked !== isParentChecked) {
      this.setState({ isChecked: !isChecked });
    }
  }

  onChangeHandler() {
    const { winterArea, parentCompany, winterAreasFilter, onSetWinterAreasFilter } = this.props;
    const { isChecked } = this.state;

    const filter = winterAreasFilter.map((x) => {
      if (x.winterAreaId === winterArea.id) {
        if (isChecked) {
          x.parentCompanies = x.parentCompanies.filter((x) => {
            return x !== parentCompany.id;
          });
        } else {
          x.parentCompanies = x.parentCompanies.concat(parentCompany.id);
        }
      }

      return x;
    })[0];

    onSetWinterAreasFilter(
      winterAreasFilter.map((x) => {
        if (x.winterAreaId === filter.winterAreaId) {
          return filter;
        }

        return x;
      })
    );
  }

  render() {
    const { winterArea, parentCompany, winterDashboard, winterCompaniesRoutesDataState, colorParentCompanies, currentFilter } = this.props;
    const { isChecked } = this.state;

    const areaDashboard = winterDashboard.areas.filter((x) => {
      return x.id === winterArea.id;
    })[0];

    const parenCompanyDashboard = areaDashboard.parentCompanies.filter((x) => {
      return x.id === parentCompany.id;
    })[0];

    const color = isChecked ? colorParentCompanies[parentCompany.id] : "#696969bd";

    return (
      <div className={styles.propsarentCompanyConainer}>
        <div className={styles.propsarentCompanyCheckboxContainer}>
          <input type="checkbox" checked={isChecked} onChange={this.onChangeHandler.bind(this)} />
          <b style={{ color: color }}>{parentCompany.title}</b>
          <div style={{ position: "absolute", right: "0px", fontWeight: "600" }}>
            {`${parenCompanyDashboard.count} из `}
            {parenCompanyDashboard.totalCount} ед т/с
          </div>
        </div>
        <WinterMaintenceCompaniesTools
          winterArea={winterArea}
          companies={parentCompany.companies}
          color={color}
          currentFilter={currentFilter}
        />
      </div>
    );
  }
}

export default withWinterMaintence(React.memo(WinterParentCompanyTools));
